import Model from 'flarum/common/Model';
import computed from 'flarum/common/utils/computed';
export default class Warning extends Model {
  publicComment() {
    return Model.attribute('publicComment').call(this);
  }
  privateComment() {
    return Model.attribute('privateComment').call(this);
  }
  strikes() {
    return Model.attribute('strikes').call(this);
  }
  createdAt() {
    return Model.attribute('createdAt', Model.transformDate).call(this);
  }
  hiddenAt() {
    return Model.attribute('hiddenAt', Model.transformDate).call(this);
  }
  isHidden() {
    return computed('hiddenAt', hiddenAt => !!hiddenAt).call(this);
  }
  warnedUser() {
    return Model.hasOne('warnedUser').call(this);
  }
  hiddenByUser() {
    return Model.hasOne('hiddenByUser').call(this);
  }
  addedByUser() {
    return Model.hasOne('addedByUser').call(this);
  }
  post() {
    return Model.hasOne('post').call(this);
  }
}
flarum.reg.add('fof-moderator-warnings', 'forum/model/Warning', Warning);